// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2oeXP","content":"styles_content__15uRC"};